import { render } from "./AppLoader.vue?vue&type=template&id=2a3cd15c&scoped=true"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=2a3cd15c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3cd15c"]])

export default __exports__